import { render, staticRenderFns } from "./SOOB_V1.vue?vue&type=template&id=376a8cf9&scoped=true&"
import script from "./SOOB_V1.vue?vue&type=script&lang=js&"
export * from "./SOOB_V1.vue?vue&type=script&lang=js&"
import style0 from "./SOOB_V1.vue?vue&type=style&index=0&id=376a8cf9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376a8cf9",
  null
  
)

export default component.exports